export interface PageComponentButtonInterface {
	title: string,
	color: string,
	background: string,
	url: string
}

export class PageComponentButtonClass implements PageComponentButtonInterface {
	background = '';
	color = '';
	title = '';
	url = '';
}
